module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/babel-loader/lib/index.js!./FbtDriverVehicle.js"));
	}, "fbt");
}


//////////////////
// WEBPACK FOOTER
// ./src/features/fbt/driver/FbtDriverVehicle.js
// module id = 2003
// module chunks = 4